import React from 'react';
import PropTypes from 'prop-types';

const PlayersListEmptyState = ({message}) => (
    <div className="players__player players__empty-state">
        <div className="container">
            <i className="left-icon fa fa-plug" />
            {message}
        </div>
    </div>
);

PlayersListEmptyState.propTypes = {
    message: PropTypes.string.isRequired,
};

export default PlayersListEmptyState;



// WEBPACK FOOTER //
// ./src/apps/create_game/components/Player/PlayersListEmptyState.js